export const AWS_INTEGRATION = {
  TITLE: 'Conecta tus cuentas de AWS',
  STEP1: {
    HELPER_TAG: 'Elige si deseas integrar una o múltiples cuentas',
    SINGLE_ACCOUNT: {
      TITLE: 'Una sola cuenta de AWS',
      DESCRIPTION: 'Ideal si gestionas todo desde una sola cuenta de AWS.',
    },
    MULTI_ACCOUNT: {
      TITLE: 'Múltiples cuentas de AWS',
      DESCRIPTION: 'Para AWS Organizations, configuraciones multi-cuenta o entornos por cuenta.',
    },
  },
  STEP2_SINGLE: {
    HELPER_TAG: 'Proporciona los metadatos de tu cuenta de AWS para comenzar el proceso.',
    ACCOUNT_ID_LABEL: 'ID de cuenta de AWS',
    ACCOUNT_ID_HELPER: 'ID numérico de 12 dígitos',
    ACCOUNT_ID_ERROR: 'Por favor ingresa tu ID de cuenta de AWS',
    ACCOUNT_ID_FORMAT_ERROR: 'El ID de cuenta de AWS debe ser un número de 12 dígitos',
    ACCOUNT_NAME_LABEL: 'Nombre visible de la cuenta',
    ACCOUNT_NAME_HELPER: 'Usado dentro de Qalea',
    ACCOUNT_NAME_ERROR: 'Por favor ingresa un nombre visible para la cuenta',
  },
  STEP2_MULTI: {
    HELPER_TAG: 'Describe las cuentas de AWS que deseas gestionar a través de StackSets.',
    ACCOUNT_ID_LABEL: 'ID de cuenta',
    ACCOUNT_NAME_LABEL: 'Nombre de cuenta',
    ADD_ACCOUNT: 'Añadir otra cuenta',
    AT_LEAST_ONE_ACCOUNT_ERROR: 'Por favor ingresa al menos una cuenta con ID y nombre',
    ORGANIZATION_ID_LABEL: 'ID de raíz / OU de AWS Organizations',
    ORGANIZATION_ID_HELPER: 'Usado como objetivo de despliegue',
    ORGANIZATION_ID_ERROR: 'Por favor ingresa tu ID de raíz organizacional o OU',
    ORGANIZATION_ID_PLACEHOLDER: 'r-examplerootid / ou-exam-pleouid',
    ORGANIZATION_ID_HELP_LINK: 'Compruébalo aquí',
  },
  STEP3_SINGLE: {
    HELPER_TAG:
      'Verifica la cuenta a continuación. Serás redirigido a AWS con un stack de CloudFormation preconfigurado.',
  },
  STEP3_MULTI: {
    HELPER_TAG: 'Ejecuta estos comandos usando AWS CLI con los prerrequisitos de StackSets configurados.',
    STEP_1_TITLE: 'Crear el StackSet',
    STEP_2_TITLE: 'Desplegar las instancias del StackSet',
    ALT_INFO_TITLE: '¿No usas StackSets?',
    ALT_INFO_ITEM_1: 'Crea stacks directamente en cada cuenta usando la',
    ALT_INFO_LINK_TEMPLATE: 'plantilla de CloudFormation',
    ALT_INFO_OR: 'o',
    ALT_INFO_LINK_GUIDE: 'guía de instalación',
    ALT_INFO_ITEM_2: 'Asegúrate de cumplir los',
    ALT_INFO_LINK_PREREQS: 'prerrequisitos de StackSets',
    ALT_INFO_ITEM_2_SUFFIX: '(acceso de confianza, roles IAM).',
  },
  FOOTER: {
    CANCEL: 'Cancelar',
    CONTINUE: 'Continuar',
    BACK: 'Atrás',
    GENERATE_CLI: 'Generar instrucciones CLI',
    OPEN_AWS: 'Abrir AWS',
    DONE: 'Hecho',
  },
  STEP_PROGRESS_SINGLE: {
    STEP_1: 'Tipo de Cuenta',
    STEP_2: 'Detalles de Cuenta',
    STEP_3: 'Revisar y Conectar',
  },
  STEP_PROGRESS_MULTI: {
    STEP_1: 'Tipo de Cuenta',
    STEP_2: 'Detalles de Cuenta',
    STEP_3: 'Instrucciones CLI',
  },
}
